import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-13",
  "use": "icon-button_icon-13-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-13\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M21 8v5m-10.8 9H4.788C3.8 22 3 21.216 3 20.25V8M12 18h9M18 14l4 4M18 22l4-4M12 2L3 8\" stroke-linecap=\"round\" /><path d=\"M12 2l9 6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol